module.exports = __webpack_public_path__ + "static/media/logo.fc4831f9.svg";